/*
 * src/components/MessageCenter/MobileView.jsx
 * Description: Responsive view
 * Copyright (c) 2020 PredictiveUX
 */
import React from "react";
import moment from "moment";

import { DEFAULT_DATE_FORMAT } from "../../utils/util";

import { messageKey } from "./mock-data";
import mobileArrowIcon from "../../styles/assets/mobile-table-arrow.svg";

const MobileView = ({ tableData }) => {
  return (
    <div className="message__mobile-table-container">
      {tableData.map((res) => {
        return (
          <div className="list-item-mobile" key={res?.id}>
            <div className="left-list">
              <p>
                <span className="dot"></span>{" "}
                {res?.transfer?.propertyAddress1 ?? "--"}
              </p>
              <p>{res?.tenant?.name}</p>
              <p>{res?.type ? messageKey[res?.type] : "N/A"}</p>
            </div>
            <div className="right-time">
              <span>{moment(res?.updatedAt).format(DEFAULT_DATE_FORMAT)}</span>
              <img src={mobileArrowIcon} alt="" />
            </div>
          </div>
        );
      })}
      {tableData.length === 0 && (
        <div className="list-item-mobile">
          <p>No Records Found</p>
        </div>
      )}
    </div>
  );
};

export default MobileView;
